import * as tslib_1 from "tslib";
import * as React from 'react';
import * as PropTypes from 'prop-types';
import cn from 'astro-classname';
import '../radio/index.css';
var Radio = (function (_super) {
    tslib_1.__extends(Radio, _super);
    function Radio() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._onChange = function (e) {
            var onChange = _this.props.onChange;
            var context = _this.context;
            var evt = tslib_1.__assign({}, e, { target: tslib_1.__assign({}, _this.props, { type: 'radio', checked: e.target.checked }) });
            if (context.radioGroup) {
                context.radioGroup.onChange(evt);
            }
            else {
                onChange(evt);
            }
        };
        return _this;
    }
    Radio.prototype.render = function () {
        var _a;
        var _b = this.props, className = _b.className, value = _b.value, checked = _b.checked, prefix = _b.prefix, text = _b.text, theme = _b.theme, disabled = _b.disabled;
        var radioGroup = this.context.radioGroup;
        var classes = cn(className, prefix + "-item", (_a = {},
            _a[prefix + "-" + theme] = theme && theme !== 'meihong',
            _a));
        var nodeProps = {
            disabled: disabled,
            onChange: this._onChange
        };
        if (radioGroup) {
            checked = value === radioGroup.value;
        }
        if (radioGroup || checked) {
            nodeProps.checked = checked;
        }
        var isMultiWords = text.length > 1;
        return (React.createElement("div", { className: prefix + "-wrapper" },
            React.createElement("input", tslib_1.__assign({ type: "radio" }, nodeProps, { className: prefix + "-input" })),
            React.createElement("div", { className: classes }, isMultiWords ? text.slice(0, 1) : text),
            isMultiWords && React.createElement("span", { className: "zhui-radio-label" }, text.slice(1))));
    };
    Radio.defaultProps = {
        className: '',
        checked: false,
        disabled: false,
        prefix: 'zhui-radio',
        onChange: function () { return null; },
        text: '',
        theme: ''
    };
    Radio.contextTypes = {
        radioGroup: PropTypes.any,
    };
    return Radio;
}(React.Component));
export default Radio;
